import { Component, OnInit } from '@angular/core';
import {TiendaService} from "../Services/tienda.service";
import {Message} from "primeng/primeng";
import {Tienda} from "../tienda/tienda";
import {UrlService} from "../Services/url.service";

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent implements OnInit {

  verReportes: boolean;
  loading = false;
  msgs: Message[] = [];
  TiendasRegistrados:Tienda[];
  tiendaId;
  fInicial;
  fFinal;

  constructor(private URL:UrlService,private servicioTienda:TiendaService) { }

  ngOnInit() {
    this.listarTiendas();
  }

  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  SeleccionarTienda(dato){
    this.tiendaId = dato;
    this.verReportes = true;
  }
  facturas(){

    let url:string = this.URL.getLocal()+'/factura/generar/excel/'+this.tiendaId;
    window.open(url,'blank');
  }
  facturasFecha(){
    if(this.fInicial && this.fFinal){
      let url:string = this.URL.getLocal()+'/factura/generar/excel/'+this.tiendaId+'/'+this.fInicial +'/'+this.fFinal;
      window.open(url,'blank');
    }else {
      alert('Debe seleccionar pimero una fecha inicial y una fecha final para el reporte')
    }

  }
  inventario(){
    let url:string = this.URL.getLocal()+'/inventario/generar/excel/'+this.tiendaId;
    window.open(url,'blank');
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/reportes/reportes.component.ts